import script from "./ConciergeCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConciergeCategory.vue?vue&type=script&setup=true&lang=ts"

import "./ConciergeCategory.vue?vue&type=style&index=0&id=1e817917&lang=scss&scoped=true"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e817917"]])

export default __exports__